<div
  class="{{ field.className }}"
  id="data-widget"
  [class.adf-invalid]="!field.isValid && isTouched()"
>
  <mat-form-field class="adf-date-widget">
    <mat-label
    class="adf-label"
    [id]="field.id + '-label'"
    [attr.for]="field.id">
      {{ field.name | translate }} ({{ field.dateDisplayFormat }})
      <span class="adf-asterisk" *ngIf="isRequired()">*</span>
    </mat-label>
    <div class="adf-date-widget-input-container">
      <input
        class="adf-date-widget-input--naked"
        matInput
        [id]="field.id"
        [value]="field.value"
        [required]="isRequired()"
        [disabled]="field.readOnly"
        [placeholder]="field.placeholder"
        (blur)="markAsTouched()"
        (change)="onDateChanged($any($event).srcElement)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="datePicker"
        [disabled]="field.readOnly"
      ></mat-datepicker-toggle>
    </div>
  </mat-form-field>
  <error-widget *ngIf="localErrors" required="{{ errorMessagesHandler | translate }}"></error-widget>
  <error-widget
    *ngIf="isInvalidFieldRequired() && isTouched()"
    required="{{ 'ADF_PROCESS_LIST.START_PROCESS.FORM.ERRORS.REQUIRED' | translate }}"
  ></error-widget>
  <mat-datepicker
    #datePicker
    [touchUi]="true"
    [startAt]="field.value | adfDateTime: 'yyyy-MM-dd HH:mm:ss'"
    [disabled]="field.readOnly"
  ></mat-datepicker>
  <input
    type="hidden"
    [matDatepicker]="datePicker"
    [value]="field.value | adfDateTime: dateFormatFixed"
    [min]="minDate"
    [max]="maxDate"
    [disabled]="field.readOnly"
    (dateInput)="onDateChanged($any($event).targetElement)"
  />
</div>
